import getErrorMessage from "../../util";
import { App_Service } from "./app.services";
import { QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_FAILURE, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_LOADING, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_STATUS_RESET, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_SUCCESS } from "./app.types";

const qc_scheduler_generate_loading_action = () => ({
  type: QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_LOADING,
  payload: null
});

const qc_scheduler_generate_success_action = (payload) => ({
  type: QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_SUCCESS,
  payload
});

const qc_scheduler_generate_failure_action = (err) => ({
  type: QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_FAILURE,
  payload: err
});

const qc_scheduler_generate_action_status_reset_action = () => ({
  type: QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_STATUS_RESET,
  payload: null
});

export const generate_schedule_action = ({ endpoint, form_data, navigate }) => async (dispatch) => {
  dispatch(qc_scheduler_generate_loading_action());
  navigate("/loading");
  // axios.post()
  try {
    console.log('making a post request for scheduling');
    const scheduler_response = await App_Service.schedule_post(endpoint, form_data);
    const data = scheduler_response.data;
    console.log({ data });
    // console.log({ data });
    if (data.status === "error") {
      throw new Error(data?.message);
    }
    if (data && data?.length > 0) {
      setTimeout(() => {
        dispatch(qc_scheduler_generate_success_action(data));
        navigate("/output");
      }, 2000);
      // console.log("saving schedule");
      // const save_response = await App_Service.schedule_post('v1/qc/save_schedule/', data);
      // const { status } = save_response.data;
      // console.log({ save_status: status });
      // if (status === "success") {
      // }
    }
  }
  catch (err) {
    // console.log('error while logging in : ', err)
    const error_message = getErrorMessage(err);
    dispatch(qc_scheduler_generate_failure_action(error_message));
    navigate("/error-while-generating-schedule");
  }
  finally {
    setTimeout(() => {
      dispatch(qc_scheduler_generate_action_status_reset_action());
    }, 1500);
  }
};